import { useEffect, useState } from "react";
import { Nav, Footer } from "../components/Nav";
import { api } from "../lib/api";
import { toast } from "sonner";

export default function Testimonials() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ student_name: "", role: "", quote: "" });
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => { api.get("/testimonials").then((r) => setItems(r.data)); }, []);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/testimonials", form);
      setSubmitted(true);
      toast.success("Thank you. Lata will review your note.");
      setForm({ student_name: "", role: "", quote: "" });
    } catch { toast.error("Something went wrong"); }
    finally { setLoading(false); }
  };

  return (
    <div className="bg-[#FAFAFA]">
      <Nav />
      <section className="max-w-6xl mx-auto px-6 md:px-10 pt-20 pb-24">
        <p className="overline mb-8"><span className="gold-line mr-3" />Voices</p>
        <h1 className="font-serif-display font-light text-5xl md:text-6xl leading-[1.05] max-w-2xl">
          Be the <span className="font-serif-italic italic text-[#D4AF37]">first</span> to write about this course.
        </h1>
        <p className="mt-8 text-[#3a3a3a] leading-relaxed max-w-lg">
          The studio is quietly opening its doors. If you've taken the course — or you're taking it now — Lata would love to hear what it felt like, in your own words.
        </p>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-12 gap-12 items-start">
          <div className="md:col-span-7">
            {submitted ? (
              <div className="border border-black/10 bg-[#F2F0EB] p-10 text-center" data-testid="review-submitted">
                <p className="overline text-[#D4AF37]"><span className="gold-line mr-3" />Received</p>
                <p className="font-serif-display text-2xl mt-4">Thank you.</p>
                <p className="text-sm text-[#3a3a3a] mt-4 max-w-sm mx-auto">Your note is with Lata. She reads every review personally, and will publish it here after approval.</p>
              </div>
            ) : (
              <form onSubmit={submit} className="border border-black/10 bg-white p-8 md:p-10 space-y-6" data-testid="be-first-form">
                <p className="overline"><span className="gold-line mr-3" />Leave a Review</p>
                <div>
                  <label className="overline">Your Name</label>
                  <input required data-testid="review-name" value={form.student_name} onChange={(e) => setForm({ ...form, student_name: e.target.value })} className="w-full border-b border-black/30 bg-transparent py-3 focus:border-black outline-none" />
                </div>
                <div>
                  <label className="overline">You Are (optional)</label>
                  <input placeholder="e.g. Fashion student · Illustrator · Designer" data-testid="review-role" value={form.role} onChange={(e) => setForm({ ...form, role: e.target.value })} className="w-full border-b border-black/30 bg-transparent py-3 focus:border-black outline-none" />
                </div>
                <div>
                  <label className="overline">What did you feel about this course?</label>
                  <textarea required rows={5} data-testid="review-quote" value={form.quote} onChange={(e) => setForm({ ...form, quote: e.target.value })} className="w-full border border-black/15 bg-[#FAFAFA] p-4 text-sm outline-none focus:border-black mt-2" />
                </div>
                <button disabled={loading} data-testid="review-submit" className="btn-editorial">
                  {loading ? "Sending…" : "Send to Lata"}
                </button>
                <p className="text-[10px] text-[#6B6B6B]">Your review will appear here after Lata's approval.</p>
              </form>
            )}
          </div>
          <div className="md:col-span-5 md:pt-2">
            <p className="overline mb-4">A quiet note from Lata</p>
            <p className="font-serif-italic italic text-xl leading-snug text-[#0A0A0A]">
              "Your words shape the studio. If the course moved you, tell me — I read every one."
            </p>
          </div>
        </div>

        {items.length > 0 && (
          <div className="mt-24 pt-16 border-t border-black/10">
            <p className="overline mb-10"><span className="gold-line mr-3" />What students have said</p>
            <div className="columns-1 md:columns-2 gap-8 space-y-8">
              {items.map((t, i) => (
                <div key={t.id || i} className="border border-black/10 bg-white p-8 break-inside-avoid" data-testid={`testimonial-${i}`}>
                  <p className="font-serif-italic italic text-xl leading-snug">"{t.quote}"</p>
                  <div className="mt-6 pt-4 border-t border-black/10">
                    <p className="text-sm font-medium">{t.student_name}</p>
                    <p className="overline mt-1">{t.role}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </section>
      <Footer />
    </div>
  );
}
